import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../modal-new";

export const RemoveDefaultTemplateModal = ({
  defaultTemplateName,
  defaultTemplateId,
  organizationCoachId
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const handleRemoveDefaultTemplate = () => {
    let body = { removeDefault: true };

    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit("/actions/annual-planner/remove-default-template", {
      method: "POST",
      body,
    });
  };

  return (
    <Modal
      className={`annual-planner-modal remove-default-template-modal`}
      title={t("removeDefaultTemplateModal.title")}
    >
      <div className="body">
        <div className="warning-wrapper">
          <span className="chip warning">
            {t("removeDefaultTemplateModal.confirmMessage")}{" "}
            <span style={{ color: "var(--white-38)" }}>
              {defaultTemplateName}
            </span>
          </span>
          <p>{t("removeDefaultTemplateModal.areYouSureContinue")}</p>
        </div>
      </div>
      <footer>
        <button
          onClick={handleRemoveDefaultTemplate}
          role="button"
          data-action="delete"
        >
          <img src="/img/new-icons/red-trash.svg" />
          {t("common:delete")}
        </button>
        <button
          onClick={() =>
            submit("/actions/refresh", {
              method: "GET",
              body: { "modal[type]": "phase-templates" },
            })
          }
          role="button"
          data-action="cancel"
          data-button-type="tertiary"
        >
          {t("common:cancel")}
        </button>
      </footer>
    </Modal>
  );
};
